import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  groupsList: [
    // {
    //   groupAccessAll:false
    //   groupName: 'Група з 13.10.224 до 5.11.2024',
    //   group_id: 'group_id_1',
    //   sortValue: 'grop_test',
    //   time_milliseconds: 12324412412414,
    // },
  ],
};

const groupsSlice = createSlice({
  name: 'groupsList',
  initialState,
  reducers: {
    // Додає список груп
    addGroupRedux(state, { payload }) {
      state.groupsList = payload;
    },
    pushGroupRedux(state, { payload }) {
      state.groupsList.unshift(payload);
    },
    toggleGroupAccessAllredux(state, { payload }) {
      const index = payload.index;
      const value = payload.value;
      if (state.groupsList[index]) {
        state.groupsList[index].groupAccessAll = value;
      }
    },
    onChangeGroupRedux(state, { payload }) {
      const group_id = payload.group_id;
      const item = payload.item;
      const value = payload.value;

      for (let index = 0; index < state.groupsList.length; index++) {
        const group = state.groupsList[index];

        if (group.group_id === group_id) {
          state.groupsList[index][item] = value;
          break;
        }
      }
    },
  },
});

export const { addGroupRedux, pushGroupRedux, toggleGroupAccessAllredux, onChangeGroupRedux } =
  groupsSlice.actions;

export default groupsSlice.reducer;
